export default "//static.tradera.net/touchweb/static/output/images/category-music.a75eef88.svg";